import React from "react";
import { FaFacebook } from "react-icons/fa";
import { FaSquareInstagram, FaSquareXTwitter } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa";
import { footerlink } from "../../Data/Vols";
import { Link } from "react-router-dom";
import { IoCallOutline } from "react-icons/io5";
import { GoMail } from "react-icons/go";

function Footer() {
  return (
    <div className="bg-black text-white">
      {/* Top Section */}
      <div className="border-t mt-10 w-full grid grid-cols-1 md:grid-cols-3 p-8 gap-10">

        {/* Social Links */}
        <div className="flex flex-col items-start gap-3">
          <h1 className="text-[16px] md:text-[18px] font-first font-extrabold">Social Links</h1>
          <div className="flex gap-5 text-[30px] md:text-[36px] mt-2">
            <a href="https://www.facebook.com/profile.php?id=61584500337779" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="hover:scale-110 hover:text-blue-500 transition duration-300" />
            </a>
            <a href="https://www.instagram.com/kondutistones/" target="_blank" rel="noopener noreferrer">
              <FaSquareInstagram className="hover:scale-110 hover:text-pink-400 transition duration-300" />
            </a>
            <a href="https://x.com/kondutistones" target="_blank" rel="noopener noreferrer">
              <FaSquareXTwitter className="hover:scale-110 hover:text-gray-400 transition duration-300" />
            </a>
          </div>
        </div>

        {/* Company Links */}
        <div className="flex flex-col gap-4 items-start">
          <h1 className="text-[16px] md:text-[18px] font-first font-extrabold">Company</h1>
          <div className="flex flex-col gap-3 text-[14px] md:text-[15px]">
            {footerlink &&
              footerlink.map((item) => (
                <Link
                  to={item.link}
                  key={item.id}
                  className="text-white group pl-2 flex items-center font-medium font-first hover:text-gray-400 transition duration-500 hover:translate-x-2"
                >
                  <span className="hidden  absolute left-[-10px] md:left-[-20px] group-hover:flex dark:group-hover:text-gray-500 group-hover:text-gray-400 transition duration-500">
                    <FaAngleRight />
                  </span>
                  {item.title}
                </Link>
              ))}
          </div>
        </div>

        {/* Contact Details */}
        <div className="flex flex-col gap-3 items-start">
          <h1 className="text-[16px] md:text-[18px] font-first font-extrabold">Contact Us</h1>
          <p className="text-gray-300 text-[14px] md:text-[15px]"><IoCallOutline className="inline mr-1" /> +91 9666666685 </p>
          <a href="mailto:sales@kondutistones.in" className="text-gray-300 text-[14px] md:text-[15px] hover:text-gray-500 duration-200"><GoMail className="inline mr-1" /> sales@kondutistones.in</a>

          {/* Google Map */}
          <div className="w-full h-40 md:h-48 rounded-lg overflow-hidden border border-gray-700 mt-2">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3821.1987935733973!2d79.64499837514988!3d16.716929984060407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x28b8efd3ee7a1953%3A0x21fb11d4841eb7b2!2sKonduti%20Stones!5e0!3m2!1sen!2sin!4v1764406328081!5m2!1sen!2sin"
          className="w-full h-full border-0"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="border-t border-gray-700 text-center py-4 text-gray-400 text-xs md:text-sm font-first">
        © 2025 Konduti Stones. All rights reserved.
      </div>
    </div>
  );
}

export default Footer;
